export const AFFILIATE_ATTRIBUTION_STORAGE_KEY = "chicchic_affiliate_attribution";
export const AFFILIATE_ATTRIBUTION_TTL_DAYS = 30;
export const AFFILIATE_ATTRIBUTION_VERSION = 1;

const TTL_MS = AFFILIATE_ATTRIBUTION_TTL_DAYS * 24 * 60 * 60 * 1000;

function getStorage() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
}

function getCourseStorageKey(courseId = "") {
  const id = String(courseId || "").trim();
  return id ? `${AFFILIATE_ATTRIBUTION_STORAGE_KEY}_${id}` : AFFILIATE_ATTRIBUTION_STORAGE_KEY;
}

export function buildAffiliateAttribution({
  code = "",
  affiliateId = "",
  affiliateUserId = "",
  courseId = "",
  courseSlug = "",
  capturedAt = Date.now(),
} = {}) {
  return {
    code: String(code || "").trim(),
    affiliateId: String(affiliateId || "").trim(),
    affiliateUserId: String(affiliateUserId || "").trim(),
    courseId: String(courseId || "").trim(),
    courseSlug: String(courseSlug || "").trim(),
    capturedAt,
    expiresAt: capturedAt + TTL_MS,
    attributionVersion: AFFILIATE_ATTRIBUTION_VERSION,
    source: "url_ref",
    activeFlow: true,
  };
}

export function saveAffiliateAttribution(attribution) {
  const storage = getStorage();
  if (!storage) return false;

  try {
    storage.setItem(getCourseStorageKey(attribution?.courseId), JSON.stringify(attribution));
    storage.removeItem(AFFILIATE_ATTRIBUTION_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}

export function readAffiliateAttribution(courseId = "") {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(getCourseStorageKey(courseId));
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;

    return parsed;
  } catch {
    return null;
  }
}

export function clearAffiliateAttribution(courseId = "") {
  const storage = getStorage();
  if (!storage) return false;

  try {
    storage.removeItem(getCourseStorageKey(courseId));
    if (courseId) {
      storage.removeItem(AFFILIATE_ATTRIBUTION_STORAGE_KEY);
    }
    return true;
  } catch {
    return false;
  }
}

export function clearAffiliateAttributionForCourse(courseId) {
  const storage = getStorage();
  if (!storage) return false;

  let removed = false;

  try {
    const current = readAffiliateAttribution(courseId);
    if (String(current?.courseId || "") === String(courseId || "")) {
      storage.removeItem(getCourseStorageKey(courseId));
      removed = true;
    }

    const legacyRaw = storage.getItem(AFFILIATE_ATTRIBUTION_STORAGE_KEY);
    if (legacyRaw) {
      const legacy = JSON.parse(legacyRaw);
      if (String(legacy?.courseId || "") === String(courseId || "")) {
        storage.removeItem(AFFILIATE_ATTRIBUTION_STORAGE_KEY);
        removed = true;
      }
    }
  } catch {
    return false;
  }

  return removed;
}

export function isAffiliateAttributionUsable(attribution, courseId) {
  if (!attribution || typeof attribution !== "object") return false;
  if (Number(attribution?.attributionVersion) !== AFFILIATE_ATTRIBUTION_VERSION) return false;
  if (!attribution?.code || !attribution?.affiliateUserId || !attribution?.courseId) return false;
  if (String(attribution.courseId) !== String(courseId || "")) return false;
  if (attribution?.source !== "url_ref" || attribution?.activeFlow !== true) return false;

  const expiresAt = Number(attribution?.expiresAt || 0);
  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) return false;

  return true;
}
